import { Hand, Zap, Wrench } from 'lucide-react';
import ProductCard, { ProductCardSkeleton } from './ProductCard';

const ICONS = {
  manual_start: Hand,
  auto_switching: Zap,
  installer: Wrench,
};

/**
 * StarterKitNextSteps — the commercially-softened "vervolgstappen" block.
 * Renders the non-measure categories (manual_start, auto_switching,
 * installer) with a friendly intro framing them as "only relevant once
 * measurement data bevestigt het nut".
 */
export default function StarterKitNextSteps({ loading, categories, onInquiry, intakeId, customerEmail }) {
  const cats = categories || [];

  return (
    <section data-testid="ec-sk-next-steps">
      <h2
        className="text-[20px] sm:text-[22px] font-medium text-primary mb-1"
        style={{ fontFamily: 'Outfit' }}
        data-testid="ec-sk-next-steps-title"
      >
        Mogelijke vervolgstappen als de metingen dit bevestigen
      </h2>
      <p className="text-sm text-muted-foreground mb-5" data-testid="ec-sk-next-steps-intro">
        Deze opties kunnen interessant worden zodra uit de meetdata blijkt waar de grootste
        bespaarkans zit. U hoeft hier nu niets mee — eerst meten.
      </p>

      {loading && cats.length === 0 && (
        <div className="space-y-6" data-testid="ec-sk-next-steps-loading">
          <ProductCardSkeleton />
          <ProductCardSkeleton />
        </div>
      )}

      <div className="space-y-8">
        {cats.map((cat) => {
          const Icon = ICONS[cat.id] || Zap;
          const products = cat.products || [];
          return (
            <div key={cat.id} data-testid={`ec-sk-category-${cat.id}`}>
              <div className="flex items-start gap-3 mb-4">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Icon className="w-5 h-5 text-primary" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3
                    className="text-[17px] sm:text-[19px] font-semibold text-primary leading-tight"
                    style={{ fontFamily: 'Outfit' }}
                  >
                    {cat.title}
                  </h3>
                  {cat.subtitle && (
                    <p className="text-[13px] text-muted-foreground mt-0.5">{cat.subtitle}</p>
                  )}
                </div>
              </div>

              {products.length === 0 ? (
                <div className="text-sm text-muted-foreground bg-muted/30 rounded-lg px-4 py-3">
                  Geen producten in deze categorie.
                </div>
              ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {products.map((p) => (
                    <ProductCard
                      key={p.product_id}
                      product={p}
                      tone="next_step"
                      onInquiry={onInquiry}
                      intakeId={intakeId}
                      customerEmail={customerEmail}
                    />
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
